export enum TableStatusEnum {
	PENDING = 'pending',
	PAID = 'paid',
	OVERDUE = 'overdue',
}
